import React from "react";
import Quote from "../aat/components/Quote/Quote";
import Banner from "../aat/components/Banner/Banner";
import Figure from "../aat/components/Image/Image";
import Text from "../aat/components/Text/Text";
import Video from "../aat/components/Video/Video";
import Accordion from "../aat/components/UI/Accordion/Accordion";
import ButtonGroup from "../components/UI/ButtonGroup/ButtonGroup";
import ImageGallery from "../aat/components/ImageGallery/ImageGallery";
import Tabs from "../aat/components/UI/Tabs/Tabs";
import { TabItemsProps } from "../aat/components/UI/Tabs/Tabs";
import OEmbed from "../components/OEmbed/OEmbed";
import Poster from "../aat/components/Show/Poster";
import { renderButton } from "./ButtonHelper";
import { ReactImageGalleryItem } from "react-image-gallery";
import SafeHtml from "../components/Html/SafeHtml";
import PortraitQuote from "../aat/components/PortraitQuote/PortraitQuote";
import Review from "../aat/components/Review/Review";
import CastMember from "../aat/components/Card/CastMember";
import InformationBar from "../aat/components/Show/InformationBar";
import { absoluteURL, addUrlParams, relativeURL } from "./UrlHelper";
// import { getImageCropUrl } from "./MediaHelper";
import StickySubMenu from "../aat/components/StickySubMenu/StickySubMenu";
import PurchaseButton from "../aat/components/Billetten/PurchaseButton";
import Slider from "../aat/components/Slider/Slider";
import Divider from "../aat/components/UI/Divider/Divider";
import {
    ButtonTypes,
    ImageControl,
    RichTextControl,
    ShowWithPosterControl,
    CodeSnippetControl,
    ReviewsControl,
    CastControl,
    SubMenuControl,
    QuoteControl,
    HeroBannerControl,
    ImageGalleryControl,
    ButtonListControl,
    OEmbedControl,
    InformationBarControl,
    QuoteWithPortraitControl,
    TabsControl,
    AccordionListControl,
    CastMemberControl,
    VideoControl,
    PopperControl,
    HeroBannerWithCalendarControl,
    CONTROL_TYPES,
    SharedModuleControl,
} from "../typings/grid";
import { MediaImage, MediaFile } from "../typings/media-types";
import { HORIZONTAL_ALIGNMENT, VERTICAL_ALIGNMENT } from "../typings/typings";
import { ThemeConsumer } from "styled-components";
import { isLight } from "./ColorHelper";
import Popper from "../aat/Grid/Modules/Popper";
import BannerWithCalendar from "../aat/components/Banner/BannerWithCalendar";
import GridControl from "../aat/Grid/GridControl";
import CodeSnippet from "../aat/components/CodeSnippet/CodeSnippet";
import { HorizontalAlignment } from "../components/types";

export const renderButtonType = (button: ButtonTypes, i: number) => {
    switch (button.content.contentType) {
        case "gridEditorButtonListItem": {
            const { style, link } = button.content.properties;
            return link && link.length > 0 ? renderButton(style, link[0], i) : null;
        }
        case "gridEditorPurchase": {
            const { tixlyEventInfo, label, style } = button.content.properties;
            const purchaseUrl = tixlyEventInfo?.purchaseUrls?.find((item) => item.culture === "da-DK")?.link;

            if (tixlyEventInfo && purchaseUrl) {
                return (
                    <PurchaseButton key={i} eventPurchaseUrl={purchaseUrl} showPurchaseUrl={tixlyEventInfo.showPurchaseUrl} style={style}>
                        {label}
                    </PurchaseButton>
                );
            }
            return null;
        }
        default:
            return null;
    }
};

export const getQuote = (ctrl: QuoteControl) => {
    const { source, text, rating, starColor } = ctrl;
    return (
        <Quote horizontalAlign="center" author={source} ratingValue={rating?.minimum} maxRatingValue={rating?.maximum} starColor={starColor}>
            {text}
        </Quote>
    );
};

export const getSubMenu = (props: SubMenuControl) => {
    const { header, menuItems } = props;

    return <StickySubMenu header={header} menuItems={menuItems} />;
};

export const getHeroBanner = (props: HeroBannerControl) => {
    const { backgroundMedia, alignmentXAxis, alignmentYAxis, showBackdrop, bodyText, buttons, linkWrap } = props;
    let images: MediaImage[] = [];
    let videoUrl = "";
    if (backgroundMedia && backgroundMedia instanceof Array && backgroundMedia.length > 0) {
        if (backgroundMedia[0].mediaType === "File") {
            const video = backgroundMedia[0] as MediaFile;
            videoUrl = absoluteURL(video.url);
        } else {
            images = backgroundMedia.filter((x) => x.mediaType === "Image") as MediaImage[];
        }
    }

    const mediaUrls: string[] = images.map((m) => {
        return absoluteURL(m.url);
    });

    const getSize = () => {
        switch (props.size) {
            case "small":
                return "sm";
            case "medium":
                return "md";
            case "large":
                return "lg";
        }
    };

    const linkUrl = linkWrap && linkWrap.length > 0 ? linkWrap[0].route?.path || linkWrap[0].url : "";
    const buttonAlignment = buttons?.items[0]?.content.properties?.buttonAlignment?.toLowerCase() ?? "left";

    return (
        <Banner
            size={getSize()}
            imageSrc={mediaUrls}
            videoSrc={videoUrl}
            horizontalAlign={(alignmentXAxis?.toLowerCase() as HORIZONTAL_ALIGNMENT) || "center"}
            verticalAlign={(alignmentYAxis?.toLowerCase() as VERTICAL_ALIGNMENT) || "center"}
            overlay={showBackdrop}
            linkWrap={linkUrl}
        >
            <Text horizontalAlign="left">
                <SafeHtml html={bodyText?.markup} />
                <ButtonGroup
                    horizontalAlign={(alignmentXAxis?.toLowerCase() as HORIZONTAL_ALIGNMENT) || "center"}
                    verticalAlign={(alignmentYAxis?.toLowerCase() as VERTICAL_ALIGNMENT) || "center"}
                >
                    {buttons?.items.map(renderButtonType)}
                </ButtonGroup>
            </Text>
        </Banner>
    );
};

export const getHeroCalendarBanner = (props: HeroBannerControl) => {
    const { backgroundMedia, alignmentXAxis, alignmentYAxis, showBackdrop, bodyText, buttons, linkWrap } = props;
    let images: MediaImage[] = [];
    let videoUrl = "";
    if (backgroundMedia && backgroundMedia instanceof Array && backgroundMedia.length > 0) {
        if (backgroundMedia[0].mediaType === "File") {
            const video = backgroundMedia[0] as MediaFile;
            videoUrl = absoluteURL(video._url || video.url);
        } else {
            images = backgroundMedia.filter((x) => x.mediaType === "Image") as MediaImage[];
        }
    }
    const mediaUrls: string[] = images.map((m) => {
        return absoluteURL(m.url);
    });

    const getSize = () => {
        switch (props.size) {
            case "small":
                return "sm";
            case "medium":
                return "md";
            case "large":
                return "lg";
        }
    };

    const linkUrl = linkWrap && linkWrap.length > 0 ? linkWrap[0].route?.path || linkWrap[0].url : "";
    const buttonAlignment = buttons?.items[0]?.content.properties?.buttonAlignment?.toLowerCase() ?? "left";

    return (
        <div className="calendar-banner__wrap">
            <Banner
                size={getSize()}
                imageSrc={mediaUrls}
                videoSrc={videoUrl}
                horizontalAlign={(alignmentXAxis?.toLowerCase() as HORIZONTAL_ALIGNMENT) || "center"}
                verticalAlign={(alignmentYAxis?.toLowerCase() as VERTICAL_ALIGNMENT) || "center"}
                overlay={showBackdrop}
                linkWrap={linkUrl}
            >
                <Text horizontalAlign="left">
                    <SafeHtml html={bodyText?.markup} />
                    <ButtonGroup horizontalAlign={buttonAlignment as HorizontalAlignment}>{buttons?.items.map(renderButtonType)}</ButtonGroup>
                </Text>
            </Banner>
        </div>
    );
};

export const getImage = (ctrl: ImageControl) => {
    const { image, caption, altText, link, aspectRatio } = ctrl;
    if (image && image.length > 0) {
        const linkItem = link && link.length > 0 ? link[0] : null;
        const linkUrl = linkItem?.route?.path || linkItem?.url || "";
        const { width, height, url } = image[0];

        const imageUrl = url;

        let heightRatio = height / width;
        switch (aspectRatio) {
            case "Circle":
            case "Square":
                heightRatio = 1;
                break;
            case "Portrait":
                heightRatio = 1.25;
                break;
            case "Landscape":
                heightRatio = 0.56;
                break;
        }

        return <Figure src={absoluteURL(imageUrl)} alt={altText} caption={caption} heightRatio={heightRatio} link={linkUrl} />;
    }
    return <div className="max-w-3xl mx-auto text-center text-red border-dashed border-4 p-4">Image is not defined.</div>;
};

//TODO: Autoplay, openInLightbox, poster?
export const getVideo = (props: VideoControl) => {
    // TODO: Autoplay
    // TODO: Poster
    const { video, autoplay } = props;
    // const posterUrl = poster ? `${baseUrl}${poster.url}` : "";
    if (video && video.umbracoFile) {
        return <Video src={absoluteURL(video.umbracoFile)} width={16} height={9} autoPlay={autoplay} />;
    }
    return <div className="max-w-3xl mx-auto text-center text-red border-dashed border-4 p-4">No video selected.</div>;
};

export const getImageGallery = (props: ImageGalleryControl) => {
    const convertToReactImages = (images: ImageControl[]): ReactImageGalleryItem[] => {
        const reactImages: ReactImageGalleryItem[] = [];
        if (images) {
            return images.reduce((images: ReactImageGalleryItem[], ctrl: ImageControl) => {
                const { image, aspectRatio, caption, altText } = ctrl.content.properties;
                if (image && image.length > 0) {
                    const { url, height, width } = image[0] as MediaImage;

                    if (url) {
                        const imageUrl = url;
                        if (imageUrl) {
                            let heightRatio = height / width;
                            let mode = "crop";
                            if (height > width) {
                                mode = "pad";
                            }
                            switch (aspectRatio) {
                                case "Circle":
                                case "Square":
                                    heightRatio = 1;
                                    break;
                                case "Portrait":
                                    heightRatio = 1.25;
                                    break;
                                case "Landscape":
                                    heightRatio = 0.56;
                                    break;
                            }

                            const url = new URL(absoluteURL(imageUrl));
                            const original = addUrlParams(url, { width: 1280, heightratio: heightRatio, mode: mode }).toString();
                            const thumbnail = addUrlParams(url, { width: 90, height: 90, mode: "crop" }).toString();

                            images.push({
                                original,
                                thumbnail,
                                description: caption,
                                originalAlt: altText,
                                thumbnailAlt: altText,
                                renderItem: () => (
                                    <div>
                                        <div style={{ position: "relative", width: "100%", paddingTop: `${heightRatio * 100}%` }}>
                                            <img
                                                src={original}
                                                alt={altText}
                                                style={{
                                                    position: "absolute",
                                                    top: 0,
                                                    left: 0,
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                }}
                                            />
                                        </div>
                                        {caption && <span className="image-gallery-description">{caption}</span>}
                                    </div>
                                ),
                            });
                        }
                    }
                }

                return images;
            }, reactImages);
        }
        return reactImages;
    };
    const { gridEditorImageGalleryImages, allowDownload, showThumbnails } = props;
    if (gridEditorImageGalleryImages && gridEditorImageGalleryImages.items.length > 0) {
        return (
            <ImageGallery
                allowDownload={allowDownload ? allowDownload : false}
                showThumbnails={showThumbnails ? showThumbnails : false}
                items={convertToReactImages(gridEditorImageGalleryImages.items)}
            />
        );
    }
    return <div className="max-w-3xl mx-auto text-center text-red border-dashed border-4 p-4">No images selected</div>;
};

export const getTabs = (props: TabsControl) => {
    const { tabItems } = props;
    if (tabItems) {
        const tabItemList: TabItemsProps[] = tabItems.items.map((tabItem) => {
            const { heading, bodyText } = tabItem.content.properties;
            return {
                title: heading || "",
                text: bodyText?.markup || "",
            };
        });
        return <Tabs tabItems={tabItemList} />;
    }
    return null;
};

export const getButtonList = (props: ButtonListControl) => {
    const buttons = props.buttons || props.content.properties.buttons;
    const buttonAlignment = buttons?.items[0]?.content.properties?.buttonAlignment?.toLowerCase() ?? "left";

    if (buttons) {
        return (
            <div
                style={{
                    margin: "0 auto",
                    maxWidth: "48rem",
                    width: "100%",
                }}
            >
                <ButtonGroup horizontalAlign={buttonAlignment as HORIZONTAL_ALIGNMENT}>
                    {buttons.items.map((button: ButtonTypes, i) => {
                        return renderButtonType(button, i);
                    })}
                </ButtonGroup>
            </div>
        );
    }

    return <div className="max-w-3xl mx-auto text-center text-red border-dashed border-4 p-4">No buttons created.</div>;
};

export const getAccordionList = (props: AccordionListControl) => {
    const { items } = props;
    if (items) {
        return (
            <div>
                {items.items.map((accordion, i) => {
                    const { heading, bodyText } = accordion.content.properties;
                    return (
                        <Accordion key={`ak_${i}`} header={heading || ""}>
                            <SafeHtml html={bodyText?.markup} />
                        </Accordion>
                    );
                })}
            </div>
        );
    }

    return <div className="max-w-3xl mx-auto text-center text-red border-dashed border-4 p-4">No accordions created.</div>;
};

export const getOEmbed = (props: OEmbedControl) => {
    const { embededContent } = props;
    if (embededContent) {
        return <OEmbed html={embededContent} />;
    }
    return null;
};

export const getRichText = (control: RichTextControl) => {
    const bodyText = control.bodyText || control.content?.properties?.bodyText;
    if (bodyText) {
        return (
            <Text
                style={{
                    "maxWidth": "48rem",
                    "margin": "0 auto",
                    "overflow": "hidden",
                }}
                className="text-wrap"
            >
                <SafeHtml html={bodyText.markup} />
            </Text>
        );
    }
    return null;
};

export const getShowWithPoster = (ctrl: ShowWithPosterControl) => {
    if (!ctrl.show) {
        return (
            <div className="max-w-3xl mx-auto text-center text-red border-dashed border-4 py-32 h-32">
                <p>No Show Data</p>
            </div>
        );
    }

    const { name } = ctrl.show;
    const { poster, venues, events, heading, previewTeaserText } = ctrl.show;
    const url = ctrl.show.route?.path || ctrl.show.url;
    const imageUrl = poster ? absoluteURL(poster.umbracoFile?.src || poster.url) : "";

    const setHeadingInnerHtml = () => {
        return {
            __html: heading || "",
        };
    };

    // first or default event
    const event = events?.find((ev) => {
        return !!(ev?.showTimes && ev?.showTimes.length > 0);
    });
    const startDate = event?.startDate;
    const eventNo = event?.eventNo;
    const isSoldOut = event?.showTimes?.every((st) => st.isSoldOut);
    const purchaseUrls = event?.purchaseUrls;

    return (
        <Poster
            href={relativeURL(url)}
            image={imageUrl}
            imageAlt={name}
            date={startDate ? new Date(startDate) : undefined}
            venues={venues}
            eventNo={eventNo}
            events={events}
            isSoldOut={isSoldOut || false}
            purchaseUrls={purchaseUrls}
            previewTeaserText={previewTeaserText}
        >
            {heading ? (
                <Text>
                    <h4 className="uppercase" dangerouslySetInnerHTML={setHeadingInnerHtml()}></h4>
                </Text>
            ) : null}
        </Poster>
    );
};

export const getProgramOverview = () => {
    return <div>Program Overview</div>;
};

export const getInformationBar = (props: InformationBarControl) => {
    const { venues, richTexts, buttons, dates } = props;

    if (richTexts || buttons || venues || dates) {
        return <InformationBar venues={venues || []} dates={dates?.markup} richTexts={richTexts?.items || []} buttons={buttons?.items || []} />;
    }
    return <div className="max-w-3xl mx-auto text-center text-red border-dashed border-4 p-4">No venues, rich texts or buttons created.</div>;
};

export const getQuoteWithProtrait = (props: QuoteWithPortraitControl) => (
    <PortraitQuote image={absoluteURL(props.portrait?.[0].url)} author={props.source}>
        <SafeHtml html={props.quote} />
    </PortraitQuote>
);

export const getReviews = (props: ReviewsControl) => (
    <div className="flex flex-wrap justify-center">
        {props.items.items.map((review, index) => {
            const reviewProps = review.content.properties;
            return (
                <div key={index} className="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 mb-4 sm:mb-0 px-4">
                    <Review
                        key={index}
                        source={reviewProps.heading}
                        ratingValue={reviewProps.rating.minimum}
                        maxRatingValue={reviewProps.rating.maximum}
                        starColor={props.starColor}
                    >
                        <SafeHtml html={reviewProps.bodyText?.markup} />
                    </Review>
                </div>
            );
        })}
    </div>
);

export const getCast = (props: CastControl) => (
    <ThemeConsumer>
        {(theme) => (
            <Slider columnWidth={4} controlsColor={isLight(theme.backgroundColor) ? "black" : "white"}>
                {props.members.items.map((member: CastMemberControl, index) => {
                    const { image, fullName, role, bodyText } = member.content.properties;

                    return (
                        <li key={index} className="slider__item">
                            <CastMember image={image?.[0].url} fullName={fullName} role={role}>
                                <SafeHtml html={bodyText?.markup} />
                            </CastMember>
                        </li>
                    );
                })}
            </Slider>
        )}
    </ThemeConsumer>
);

export const getDivider = () => <Divider />;

export const getCodeSnippet = (control: CodeSnippetControl) => {
    return <CodeSnippet {...control} />;
};

export const getPopper = (control: PopperControl) => {
    return <Popper {...control} />;
};

export const getHeroBannerWithCalendarControl = (props: HeroBannerWithCalendarControl) => {
    return <BannerWithCalendar {...props} />;
};

export const getSharedModule = (props: SharedModuleControl) => {
    const { modules } = props.sharedModule;
    return modules.map((value: CONTROL_TYPES, index: number) => {
        return <GridControl key={`gc_${index}`} control={value} />;
    });
};
